/**
 *   Generated file. Do not edit
 */

import { createEnumConverter } from '@iotize/tap/service/core';
import { createEnumArrayConverter } from '@iotize/tap/service/core';
import { FixedSizeEnumConverter } from '@iotize/tap/client/impl';
import { ArrayConverter } from '@iotize/tap/client/impl';
import { EnumListConverter } from '@iotize/tap/client/impl';
import { GPIOMode } from './models';

export const gPIOMode = createEnumConverter<GPIOMode>(GPIOMode, 1);

export const gPIOModeArray = createEnumArrayConverter<GPIOMode>(GPIOMode, 1);
